// src/features/owner/sections/PlaceholderSection.tsx — temporary body until each section is built.
export function PlaceholderSection({ label }: { label: string }) {
  return <p style={{ opacity: 0.7 }}>{label}: coming in a later phase.</p>;
}
